import { createScrollXSync } from 'presentation/libs/ScrollXSync/ScrollXSync'

export const CMAEntriesTableScrollXSync = createScrollXSync()
